module.exports = __webpack_public_path__ + "./images/p10.JPG?06bee49f9251f2e499ff95f3444faadc";


//////////////////
// WEBPACK FOOTER
// ./src/products/p10.JPG
// module id = 45
// module chunks = 0